import React, { Component } from 'react';
interface Props {
  children: React.ReactNode;
}
interface State {
  hasError: boolean;
}
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: any, info: any) {
    // Swallow — never blank the page just because a non-critical effect threw.
    // eslint-disable-next-line no-console
    console.warn('UI error caught:', error, info);
  }
  render() {
    if (this.state.hasError) {
      // Fail silently — keep the rest of the page visible.
      return null;
    }
    return this.props.children;
  }
}